import React from 'react';
import { useTranslation } from 'react-i18next';
import { DesktopSidebarLogo } from './logo';
import { DesktopSidebarNavItem } from './navItem';
import { DesktopSidebarToggle } from './toggle';
import { QuickLinks } from './quickLinks';

export const DesktopSidebar = ({ isOpen, setIsOpen, sidebarNavigation, containerClasses }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`bg-pddarkblue hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col lg:text-xl ${isOpen ? 'lg:w-108' : 'items-center lg:w-42'} ${containerClasses}`}
      data-isopen={isOpen}
    >
      <div
        data-testid='desktop-sidebar-container'
        className={`bg-danger flex grow flex-col gap-y-5 overflow-y-auto p-6 ${!isOpen ? 'items-center px-3' : ''}`}
      >
        <DesktopSidebarLogo isOpen={isOpen} />

        <nav className="flex flex-1 flex-col">
          <ul role="list" className={`${!isOpen && 'items-center'} flex flex-col shadow-none lg:p-3`}>
            <li data-testid='desktop-sidebar-nav-items'>
              {sidebarNavigation.map((item, i) => (
                <DesktopSidebarNavItem key={`menu-${i}`} item={item} isOpen={isOpen} t={t} />
              ))}
            </li>
          </ul>

          {isOpen && (
            <div className="mx-4 block p-6">
              <QuickLinks />
            </div>
          )}
        </nav>

        <DesktopSidebarToggle isOpen={isOpen} setIsOpen={setIsOpen} t={t} />
      </div>
    </div>
  );
};
